import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown",
  "use": "icon-dropdown-usage",
  "viewBox": "0 0 1792 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1792 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dropdown\"><defs><style type=\"text/css\"></style></defs><path d=\"M217.856 45.824h1356.288a128 128 0 0 1 90.624 218.496L986.496 942.592a128 128 0 0 1-180.992 0L127.232 264.32A128 128 0 0 1 217.856 45.824z\" p-id=\"1315\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol